import { AnalysisValueProps } from './types';
import { AnalysisString } from './analysis-string-value';
import { AnalysisSelection } from './analysis-select-value';
import { AnalysisBoolean } from './analysis-bool-value';
import { AnalysisPath } from './analysis-path-value';
import { AnalysisObject } from './analysis-object-value';
import { AnalysisList } from './analysis-list-value';

export function AnalysisSwitchValue(props: AnalysisValueProps) {
  const { value, ...sharedProps } = props;
  switch (props.value._type) {
    case 'object':
      return <AnalysisObject value={props.value} {...sharedProps} />;
    case 'path':
      return <AnalysisPath value={props.value} {...sharedProps} />;
    case 'boolean':
      return <AnalysisBoolean value={props.value} {...sharedProps} />;
    case 'selection':
      return <AnalysisSelection value={props.value} {...sharedProps} />;
    case 'string':
      return <AnalysisString value={props.value} {...sharedProps} />;
    case 'list':
      return <AnalysisList value={props.value} {...sharedProps} />;
    default:
      return (
        <div className="text-red-500">
          Invalid Type: {JSON.stringify(props.value)}
        </div>
      );
  }
}
